import { ShareBlockProps } from '@design-system/share-block';

import { linkMapper } from '~/mappers/link';

import { ShareBlock } from './models';

export const shareBlockMapper = (
  shareBlock: ShareBlock
): ShareBlockProps | null => {
  if (!shareBlock) return null;

  const {
    shareLinks,
    label,
    showCopyButton,
    shareButtonAriaLabel,
    copyButtonDefaultLabel,
    copyButtonAriaLabel,
    copyButtonActiveLabel,
    align,
  } = shareBlock;

  return {
    ...(label && { label }),
    ...(showCopyButton && { showCopyButton }),
    ...(shareButtonAriaLabel && { shareButtonAriaLabel }),
    ...(copyButtonDefaultLabel && { copyButtonDefaultLabel }),
    ...(copyButtonAriaLabel && { copyButtonAriaLabel }),
    ...(copyButtonActiveLabel && { copyButtonActiveLabel }),
    ...(shareLinks?.length && {
      shareLinks: shareLinks.map((item) => linkMapper(item)),
    }),
    ...(align && { align }),
  } as ShareBlockProps;
};
